"use client";

import { useParams, usePathname } from "next/navigation";
import { defaultLocale } from "@/config/locale";

function useSelectedPathname() {
	const pathname = usePathname();
	const { locale } = useParams<{ locale?: string }>();
	const loc = locale ?? defaultLocale;

	if (loc === defaultLocale) {
		return pathname;
	}

	const prefix = `/${loc}`;
	if (pathname === prefix) {
		return "/";
	}
	if (pathname.startsWith(`${prefix}/`)) {
		return pathname.slice(prefix.length) || "/";
	}
	return pathname;
}

export default useSelectedPathname;
